module.exports = __webpack_public_path__ + "img/joseph-lister.1cf62c38.png";